import corpManager from 'ui/assets/img/corp_manager.png';
import customersupport from 'ui/assets/img/customer_support.png';
import dataanalyst from 'ui/assets/img/data_analyst.png';
import fotamanager from 'ui/assets/img/fota.png';
import siteManager from 'ui/assets/img/site_manager.png';
import systemadmin from 'ui/assets/img/system_admin.png';
// import partnerportaladmin from 'ui/assets/img/partner_portal_admin.png';
import commPartnerAdmin from 'ui/assets/img/comm-partner-admin.png';
import commPartner from 'ui/assets/img/comm-partner.png';
import sysAdmin from 'ui/assets/img/system-admin-partner.png';
import techPartnerAdmin from 'ui/assets/img/tech-partner-admin.png';
import techPartner from 'ui/assets/img/tech-partner.png';

export const Role = {
  CustomerSupport: 'Customer Support',
  SystemAdmin: 'System Admin',
  FOTA: 'FOTA',
  DataAnalyst: 'Data Analyst',
  CustomerSupportExternal: 'Customer Support Ext.',
  Owner: 'Owner'
};

export const CorporateRoles = {
  CorporateManager: 'Corporate Manager',
  CorporateSiteManager: 'Site Manager',
  CorporateOwner: 'Corporate Owner'
};

export const RoleImages = {
  CustomerSupport: customersupport,
  SystemAdmin: systemadmin,
  FOTA: fotamanager,
  DataAnalyst: dataanalyst,
  CustomerSupportExternal: customersupport,
  Owner: systemadmin,
  CorporateManager: corpManager,
  CorporateSiteManager: siteManager,
  CorporateOwner: systemadmin,
  PartnerPortalAdmin: sysAdmin,
  BusinessAdmin: commPartnerAdmin,
  BusinessUser: commPartner,
  TechnicalAdmin: techPartnerAdmin,
  TechnicalUser: techPartner
};

export const PartnerRoles = {
  TechnicalUser: 'Technical User',
  TechnicalAdmin: 'Technical Admin',
  BusinessUser: 'Commercial User',
  BusinessAdmin: 'Commercial Admin',
  SystemAdmin: 'System Admin',
  PartnerPortalAdmin: 'Partner Portal Admin'
};
